// export default function useStore(vm) {
//   return vm?.proxy?.$store
// }

// import { Store } from 'vuex'
// import { ComponentInternalInstance } from 'vue'
// todo 自测
const useStore = vm => {
  // const vm = getCurrentInstance()
  return vm?.proxy.$store
}

export default useStore
